import React from 'react';
import './css/Card.css'

export default class Card extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    const {titulo, children} = this.props;
    const width = this.props.width === undefined ? 400 : this.props.width;
    return(
      <div className="Card" style={{width}}>
        <div className="Titulo">
          <span style={{textAlign:'center', fontSize:20}}>{titulo}</span>
        </div>
        <div className="Descripcion">
          <span style={{textAlign:'center'}}>
            {children}
          </span>
        </div>
      </div>
    )
  }
}
